import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavLink } from 'core/types/nav-link';

@Component({
  selector: 'app-root',
  template: `
      <app-main-layout [navLinks]="navLinks">
      </app-main-layout>`,
  styleUrls: ['./root-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RootLayoutComponent {
  navLinks: NavLink[] = [
    {
      path: '/root/managers',
      icon: 'supervised_user_circle',
      linkActiveOptions: { exact: true },
      label: 'SIDENAV.ROOT.users',
    },
    {
      path: '/root/projects',
      icon: 'casino',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.ROOT.projects',
    },
    {
      path: '/root/extensions',
      icon: 'build',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.ROOT.modules',
      children: [
        {
          path: '/root/extensions/couriers',
          linkActiveOptions: { exact: false },
          label: 'SIDENAV.ROOT.couriers',
        },
        {
          path: '/root/extensions/documents',
          linkActiveOptions: { exact: false },
          label: 'SIDENAV.ROOT.documents',
        },
        {
          path: '/root/extensions/simple-extensions',
          linkActiveOptions: { exact: false },
          label: 'SIDENAV.ROOT.extensions',
        },
      ],
    },
    {
      path: '/root/integration',
      icon: 'settings_input_hdmi',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.ROOT.webhooks',
    },
    {
      path: '/root/association',
      icon: 'accessibility_new',
      linkActiveOptions: { exact: false },
      label: 'SIDENAV.ROOT.associations',
    },
  ];
}
